import { instance } from "./apiClient";

export const capitalApi = {
  getCapitalOverview: () =>
    instance.get("/api/capital").then((res) => res.data),

  getCapitalDetails: () =>
    instance.get("/api/capital/details").then((res) => res.data),
};
